import { AbstractHook } from '@hooks/abstraction';
import { UserResponse } from 'layouts/pages/System/users/services/responses/user.response';
import { UserService } from 'layouts/pages/System/users/services/user.service';

export class UserHook extends AbstractHook<UserResponse, UserService> {}
